import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/abc.png'
import _imports_1 from '@/assets/images/icons/light.png'
import _imports_2 from '@/assets/images/icons/has_media.png'
import _imports_3 from '@/assets/images/icons/has_taught.png'
import _imports_4 from '@/assets/images/icons/goal-arrow.png'
import _imports_5 from '@/assets/images/illustrations/nk.png'
import _imports_6 from '@/assets/images/illustrations/milk.png'
import _imports_7 from '@/assets/images/illustrations/moon.png'
import _imports_8 from '@/assets/images/illustrations/tisue.png'


const _withScopeId = n => (_pushScopeId("data-v-fcdc2024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "__report-student pb-30 px-10 md-down:px-4" }
const _hoisted_3 = { class: "pt-10" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center" }
const _hoisted_6 = { class: "__breadcrumbs__decorate" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Xem báo cáo", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2 text-neutral-400",
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_9 = { class: "__report-student__header pt-5" }
const _hoisted_10 = { class: "flex justify-between items-center w-full" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "font-medium leading-none text-white text-4xl" }
const _hoisted_14 = { class: "ml-4" }
const _hoisted_15 = { class: "font-bold text-neutral-700 text-4xl md-down:text-2xl" }
const _hoisted_16 = {
  key: 0,
  class: "text-green-500 font-semibold text-xs uppercase letter-spacing-8"
}
const _hoisted_17 = {
  key: 1,
  class: "text-green-500 font-semibold text-xs uppercase"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-4" }, null, -1))
const _hoisted_19 = { class: "border-b border-neutral-200 mt-4" }
const _hoisted_20 = {
  "aria-label": "Tabs",
  class: "flex space-x-8 tabs"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-sienna-50 border-l-4 border-sienna-500 p-4 rounded-md" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "relative text-sm text-gray-600" }, [
    /*#__PURE__*/_createTextVNode(" Bạn đang xem bản nháp của báo cáo. Hãy sử dụng app Trị liệu viên để hoàn thành báo cáo này nhé. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Phụ huynh sẽ không nhận được báo cáo chưa hoàn thành ")
  ])
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "mt-10" }
const _hoisted_27 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-orange-50 p-4 px-6 font-semibold text-lg text-gray-700" }, " Báo cáo can thiệp cá nhân ", -1))
const _hoisted_29 = { class: "flex items-center justify-between flex-nowrap md-down:flex-col md-down:items-start p-4 px-6" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_32 = { class: "flex items-center justify-between flex-nowrap md-down:flex-col md-down:items-start p-4 pt-0 px-6" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "font-semibold text-blue-700" }
const _hoisted_37 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_38 = { class: "bg-white shadow-sm rounded-2xl" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600 p-6" }, " Ghi chú ", -1))
const _hoisted_40 = { class: "p-6 border-t border-orange-100" }
const _hoisted_41 = { class: "mt-10" }
const _hoisted_42 = { class: "p-6 bg-white shadow-sm rounded-2xl" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600 mb-6" }, " Thống kê chung ", -1))
const _hoisted_44 = { class: "flex flex-nowrap w-full" }
const _hoisted_45 = { class: "p-6 border rounded-l-lg border-neutral-200 w-full" }
const _hoisted_46 = { class: "text-33 font-bold text-neutral-600 mb-6 md-down:text-center flex flex-nowrap items-center" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_0,
  style: {"height":"32px"},
  width: "32"
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực đã học ")
], -1))
const _hoisted_49 = { class: "p-6 border rounded-r-lg border-neutral-200 w-full border-l-0" }
const _hoisted_50 = { class: "text-33 font-bold text-neutral-600 mb-6 md-down:text-center flex flex-nowrap items-center" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_1,
  style: {"height":"32px"},
  width: "32"
}, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu đã học")
], -1))
const _hoisted_53 = { class: "mt-10" }
const _hoisted_54 = { class: "flex md-down:flex-col" }
const _hoisted_55 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden w-1/2 mr-8 md-down:mr-0 md-down:w-full md-down:mb-8" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Biểu đồ kết quả mục tiêu đã học ", -1))
const _hoisted_57 = { class: "flex flex-nowrap md-down:flex-col p-6 border-t border-orange-50 items-center" }
const _hoisted_58 = {
  key: 0,
  class: "relative md-down:mb-8 w-3/5"
}
const _hoisted_59 = {
  class: "text-center absolute top-1/2 left-1/2 transform",
  style: {"transform":"translate(\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t-50%,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t-50%\n\t\t\t\t\t\t\t\t\t\t\t\t\t)"}
}
const _hoisted_60 = { class: "text-4xl font-bold text-neutral-600" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, " Mục tiêu ", -1))
const _hoisted_62 = { class: "flex flex-col justify-center md-down:mt-4" }
const _hoisted_63 = {
  key: 0,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_64 = { class: "text-sm font-semibold text-neutral-500 w-14 blue" }
const _hoisted_65 = {
  class: "flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input",
  style: {"background":"#2aa797"}
}
const _hoisted_66 = {
  key: 1,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_67 = { class: "text-sm text-neutral-500 w-14 font-semibold" }
const _hoisted_68 = {
  class: "flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input",
  style: {"background":"#65a30d"}
}
const _hoisted_69 = {
  key: 2,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_70 = { class: "text-sm font-semibold text-neutral-500 w-14" }
const _hoisted_71 = {
  class: "flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input",
  style: {"background":"#f59e0b"}
}
const _hoisted_72 = {
  key: 3,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_73 = { class: "text-sm font-semibold text-neutral-500 w-14 blue" }
const _hoisted_74 = {
  class: "flex items-center justify-center px-3 py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input",
  style: {"background":"#f87171"}
}
const _hoisted_75 = {
  key: 4,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_76 = { class: "text-sm font-semibold text-neutral-500 w-14 blue" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "flex items-center justify-center px-3 py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input",
  style: {"background":"#9ca3af"}
}, " X ", -1))
const _hoisted_78 = { class: "w-1/2 md-down:w-full flex md-down:flex-col" }
const _hoisted_79 = { class: "bg-white shadow-sm rounded-2xl w-1/2 md-down:w-full pb-8 mr-8 md-down:mr-0 md-down:mb-8" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Mức độ tham gia ", -1))
const _hoisted_81 = { class: "p-6 border-t border-orange-100 text-neutral-700 flex items-center flex-col" }
const _hoisted_82 = { class: "bg-white shadow-sm rounded-2xl h-full w-1/2 md-down:w-full" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Nhiệt kế cảm xúc ", -1))
const _hoisted_84 = { class: "p-6 border-t border-orange-100 text-neutral-700 flex items-center flex-col" }
const _hoisted_85 = ["src"]
const _hoisted_86 = {
  key: 0,
  class: "w-full text-center mt-4"
}
const _hoisted_87 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-10\" data-v-fcdc2024><div class=\"relative\" data-v-fcdc2024><div aria-hidden=\"true\" class=\"absolute inset-0 flex items-center\" data-v-fcdc2024><div class=\"w-full border-t border-neutral-300\" data-v-fcdc2024></div></div><div class=\"relative flex justify-center cursor-pointer\" data-v-fcdc2024><div class=\"px-3 bg-body p-2 text-lg font-semibold text-neutral-600 flex items-center\" data-v-fcdc2024><div class=\"ml-2 text-sm text-neutral-600\" data-v-fcdc2024> Kết quả mục tiêu đã học </div></div></div></div></div>", 1)
const _hoisted_88 = { class: "font-semibold text-lg text-neutral-600 mb-2" }
const _hoisted_89 = { class: "shadow-sm sm:rounded-2xl overflow-hidden md-down:hidden" }
const _hoisted_90 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_91 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_92 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-16",
      scope: "col"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col",
      style: {"width":"376px"}
    }, " Mục Tiêu "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col",
      style: {"width":"145px"}
    }, " Kết quả "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col",
      style: {"width":"150px"}
    }, " Hoạt động "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col",
      style: {"width":"76px"}
    }, " ALBUM "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col",
      style: {"width":"120px"}
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "w-40" }, " Ghi Chú ")
    ])
  ])
], -1))
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "px-3 py-4 text-center whitespace-nowrap text-neutral-700" }
const _hoisted_96 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_97 = ["innerHTML"]
const _hoisted_98 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_99 = { class: "flex items-center gap-2 mt-2" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_2
}, null, -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = { class: "text-neutral-400 text-xs font-semibold" }
const _hoisted_104 = { key: 1 }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_3
}, null, -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = {
  key: 1,
  class: "goal-block flex gap-3 mt-2"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-3 h-3 mt-1",
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_109 = ["innerHTML"]
const _hoisted_110 = { class: "text-neutral-400 text-xs font-semibold" }
const _hoisted_111 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_112 = {
  key: 0,
  class: "whitespace-normal"
}
const _hoisted_113 = { class: "whitespace-nowrap text-neutral-700" }
const _hoisted_114 = { class: "pl-5 py-4" }
const _hoisted_115 = ["onClick"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z",
  fill: "#E5A42B",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z",
  fill: "#E5A42B",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_118 = [
  _hoisted_116,
  _hoisted_117
]
const _hoisted_119 = {
  class: "px-3 py-4",
  style: {"min-width":"300px"}
}
const _hoisted_120 = { class: "whitespace-normal mb-1" }
const _hoisted_121 = {
  key: 0,
  class: "py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit shadow-input"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "14",
  viewBox: "0 0 14 14",
  width: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0903 6.125H13.5312C13.7166 6.125 13.818 6.34131 13.6992 6.48379L11.9788 8.54834C11.8913 8.65329 11.7301 8.65329 11.6427 8.54834L9.92221 6.48379C9.80348 6.34131 9.9048 6.125 10.0903 6.125Z",
    fill: "#344256"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.465262 7.875H3.90618C4.09165 7.875 4.19296 7.65869 4.07423 7.51621L2.35377 5.45166C2.26631 5.34671 2.10513 5.34671 2.01767 5.45166L0.297213 7.51621C0.178482 7.65869 0.279798 7.875 0.465262 7.875Z",
    fill: "#344256"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M6.99822 2.625C5.63979 2.625 4.42622 3.2436 3.62307 4.21609C3.46921 4.40239 3.19345 4.42869 3.00715 4.27483C2.82084 4.12097 2.79454 3.84521 2.94841 3.65891C3.91065 2.49377 5.36776 1.75 6.99822 1.75C9.57221 1.75 11.7127 3.60194 12.1617 6.04596C12.1665 6.07224 12.1711 6.09859 12.1756 6.125H11.2858C10.8807 4.12806 9.11452 2.625 6.99822 2.625ZM2.71065 7.875C3.11579 9.87194 4.88192 11.375 6.99822 11.375C8.35665 11.375 9.57023 10.7564 10.3734 9.78391C10.5272 9.59761 10.803 9.57131 10.9893 9.72517C11.1756 9.87903 11.2019 10.1548 11.048 10.3411C10.0858 11.5062 8.62868 12.25 6.99822 12.25C4.42423 12.25 2.2837 10.3981 1.83477 7.95404C1.82995 7.92776 1.82531 7.90141 1.82088 7.875H2.71065Z",
    fill: "#344256",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_123 = [
  _hoisted_122
]
const _hoisted_124 = ["onClick"]
const _hoisted_125 = { class: "font-semibold text-neutral-600 p-4" }
const _hoisted_126 = { class: "flex items-center" }
const _hoisted_127 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_128 = {
  key: 1,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_129 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_130 = { class: "p-4 border-t border-orange-100" }
const _hoisted_131 = {
  key: 0,
  class: "uppercase font-semibold text-neutral-400"
}
const _hoisted_132 = {
  key: 0,
  class: "w-60 whitespace-normal"
}
const _hoisted_133 = {
  key: 1,
  class: "mt-4 uppercase font-semibold text-neutral-400"
}
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 uppercase font-semibold text-neutral-400" }, " Kết quả ", -1))
const _hoisted_135 = { key: 1 }
const _hoisted_136 = { class: "mt-10" }
const _hoisted_137 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-orange-50 p-4 px-6 font-semibold text-lg text-gray-700" }, " Báo cáo bán trú ", -1))
const _hoisted_139 = { class: "p-4 px-6" }
const _hoisted_140 = { class: "flex items-center justify-between flex-nowrap mb-2 md-down:flex-col md-down:items-start" }
const _hoisted_141 = { key: 0 }
const _hoisted_142 = { key: 0 }
const _hoisted_143 = { class: "font-semibold text-blue-700" }
const _hoisted_144 = { class: "flex items-center justify-between flex-nowrap mb-2 md-down:flex-col md-down:items-start" }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = { key: 0 }
const _hoisted_147 = { class: "font-semibold text-blue-700" }
const _hoisted_148 = { class: "mt-10" }
const _hoisted_149 = { class: "bg-white shadow-sm rounded-2xl" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600 p-6" }, " Nhận xét chung ", -1))
const _hoisted_151 = { class: "p-6 border-t border-orange-100 grid md-down:grid-cols-1 grid-cols-2 xl:grid-cols-4 gap-4" }
const _hoisted_152 = { class: "flex items-center" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "48",
  src: _imports_5,
  width: "48"
}, null, -1))
const _hoisted_154 = { class: "ml-4" }
const _hoisted_155 = { class: "flex items-center" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "40",
  src: _imports_6,
  width: "40"
}, null, -1))
const _hoisted_157 = { class: "flex items-center" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "48",
  src: _imports_7,
  width: "48"
}, null, -1))
const _hoisted_159 = { class: "flex items-center w-full" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "48",
  src: _imports_8,
  width: "48"
}, null, -1))
const _hoisted_161 = { class: "ml-4 w-full" }
const _hoisted_162 = { class: "flex justify-between w-full" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-4 whitespace-nowrap" }, " Vệ sinh nhẹ ", -1))
const _hoisted_164 = { class: "flex justify-between w-full" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-4 whitespace-nowrap" }, " Vệ sinh nặng ", -1))
const _hoisted_166 = { class: "text-capitalize" }
const _hoisted_167 = {
  key: 0,
  class: "bg-white shadow-sm rounded-2xl"
}
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600 p-6" }, " Hoạt động ", -1))
const _hoisted_169 = { class: "p-6 border-t border-orange-100 pl-14" }
const _hoisted_170 = { class: "list-disc" }
const _hoisted_171 = { class: "bg-white shadow-sm rounded-2xl text-center" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600 p-6" }, " Nhận xét chung & Nhận xét buổi học ", -1))
const _hoisted_173 = { class: "p-6 border-t border-orange-100 flex items-center justify-center flex-col" }
const _hoisted_174 = ["innerHTML"]
const _hoisted_175 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyModal = _resolveComponent("CopyModal")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_ViewPhoto = _resolveComponent("ViewPhoto")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Rating = _resolveComponent("Rating")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CopyModal, {
          path: _ctx.path,
          "onUpdate:path": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.path) = $event)),
          onClose: _ctx.closeShare
        }, null, 8, ["path", "onClose"])
      ]),
      _: 1
    }, 8, ["open"]),
    (_ctx.imageShow && _ctx.photos.length)
      ? (_openBlock(), _createBlock(_component_ViewPhoto, {
          key: _ctx.photosIndex,
          images: _ctx.photos,
          index: _ctx.photosIndex,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imageShow = false))
        }, null, 8, ["images", "index"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_router_link, {
                      to: {
									path: _ctx.is_old_data
										? '/transferred-data'
										: '/report/lesson',
								}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.is_old_data
										? 'Xem hồ sơ cũ'
										: 'Danh sách học sinh'), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_DaIcon, {
                        class: "transform -rotate-90 h-3 w-3 mx-2",
                        name: "das--chevron-down"
                      })
                    ]),
                    _hoisted_7
                  ]),
                  (_ctx.is_old_data)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
                      }, [
                        _hoisted_8,
                        _createTextVNode(" Thoát ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: `/record/student/${_ctx.student?.id}`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          (_ctx.student?.profile_photo?.w200)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.student?.profile_photo?.w200,
                                alt: "",
                                class: "shadow-sm inline-block h-14 w-14 rounded-full"
                              }, null, 8, _hoisted_12))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                style: _normalizeStyle({
											background:
												_ctx.student?.profile_photo?.default
													?.color,
										}),
                                class: "inline-flex items-center justify-center h-14 w-14 rounded-full"
                              }, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.student?.profile_photo?.default
													?.initial), 1)
                              ], 4)),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.student?.name), 1),
                            (_ctx.is_old_data && _ctx.dateData)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.dateData), 1))
                              : (_ctx.student?.age)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.student?.age) + " " + _toDisplayString(_ctx.student?.learning_time
													? `| ${_ctx.student?.learning_time}`
													: ''), 1))
                                : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _hoisted_18
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("nav", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataOfReport, (no, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass([
								_ctx.tab === index
									? 'border-b-2 text-yellow-700 border-yellow-500'
									: 'text-neutral-500'
							, "order-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap pb-6 pt-8 px-1 font-semibold cursor-pointer"]),
                      onClick: ($event: any) => (_ctx.tab = index)
                    }, _toDisplayString(no.key === 'lesson_report' // eslint-disable-next-line no-mixed-spaces-and-tabs // eslint-disable-next-line no-mixed-spaces-and-tabs
									? `Học cá nhân ${_ctx.timeLearning(
											// eslint-disable-next-line no-mixed-spaces-and-tabs
											no.data.session // eslint-disable-next-line no-mixed-spaces-and-tabs
									  )}` // eslint-disable-next-line no-mixed-spaces-and-tabs
									: `Kết quả học bán trú`), 11, _hoisted_21))
                  }), 128))
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataOfReport, (report, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (
							report.key === 'lesson_report' &&
							report.data?.id &&
							_ctx.tab === index
						)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (report.data?.state !== 'completed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, [
                              (report.data?.date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.$filters.getDay(report.data?.date)) + " - " + _toDisplayString(_ctx.$filters.formatDate2(
												report.data?.date
											)), 1))
                                : _createCommentVNode("", true),
                              _hoisted_31
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              (report.data?.date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createTextVNode(_toDisplayString(report.data.session
												?.display_start_slot) + " ", 1),
                                    (
												report.data.session
													?.display_end_slot
											)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, " - " + _toDisplayString(report.data.session
													?.display_end_slot), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_router_link, {
                                to: `/record/student/${report.data?.submitted_by_staff?.id}`
                              }, {
                                default: _withCtx(() => [
                                  (
												report.data?.submitted_by_staff
											)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        _createTextVNode(" Trị liệu viên "),
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(report.data
														?.submitted_by_staff
														?.name), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ]),
                        (report.data?.note)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                _createElementVNode("div", _hoisted_40, _toDisplayString(report.data?.note), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createTextVNode(" " + _toDisplayString(report.count?.skill), 1)
                                ]),
                                _hoisted_48
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                  _hoisted_51,
                                  _createTextVNode(" " + _toDisplayString(report.count?.goal), 1)
                                ]),
                                _hoisted_52
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("div", _hoisted_57, [
                                (_ctx.chartData[index])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _createVNode(_component_apexchart, {
                                        options: _ctx.chartOptions,
                                        series: 
													_ctx.chartData[index]?.series
												,
                                        height: "220",
                                        type: "donut"
                                      }, null, 8, ["options", "series"]),
                                      _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, _toDisplayString(report.count?.goal), 1),
                                        _hoisted_61
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_62, [
                                  (
													_ctx.chartData[index] &&
													_ctx.chartData[index]
														?.assessment_result[0]
														?.value > 0
												)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[0]
															?.value) + " M.T ", 1),
                                        _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[0]
															?.name), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
													_ctx.chartData[index] &&
													_ctx.chartData[index]
														?.assessment_result[1]
														?.value > 0
												)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[1]
															?.value) + " M.T ", 1),
                                        _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[1]
															?.name), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
													_ctx.chartData[index] &&
													_ctx.chartData[index]
														?.assessment_result[2]
														?.value > 0
												)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                        _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[2]
															?.value) + " M.T ", 1),
                                        _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[2]
															?.name), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
													_ctx.chartData[index] &&
													_ctx.chartData[index]
														?.assessment_result[3]
														?.value > 0
												)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                        _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[3]
															?.value) + " M.T ", 1),
                                        _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[3]
															?.name), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
													_ctx.chartData[index] &&
													(_ctx.chartData[index]
														?.assessment_result[4]
														?.value > 0 ||
														_ctx.chartData[index]
															?.assessment_result[5]
															?.value > 0 ||
														_ctx.chartData[index]
															?.assessment_result[6]
															?.value > 0)
												)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                        _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.chartData[index]
															?.assessment_result[4]
															?.value +
														_ctx.chartData[index]
															?.assessment_result[5]
															?.value +
														_ctx.chartData[index]
															?.assessment_result[6]
															?.value) + " M.T ", 1),
                                        _hoisted_77
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("div", _hoisted_79, [
                                _hoisted_80,
                                _createElementVNode("div", _hoisted_81, [
                                  _createVNode(_component_Rating, {
                                    rating: 
													report.data
														.cooperation_scale || 0
												,
                                    class: "max-w-min py-6"
                                  }, null, 8, ["rating"]),
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$filters.cooperation(
														report.data
															.cooperation_scale +
															'' || '0'
													)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_82, [
                                _hoisted_83,
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("div", null, [
                                    (
														report.data
															.emotion_scale
													)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: 
														require(`@/assets/images/emoji/${
															_ctx.$filters.emoji(
																report.data
																	.emotion_scale +
																	''
															).emoji
														}`)
													,
                                          alt: "",
                                          height: "120",
                                          width: "120"
                                        }, null, 8, _hoisted_85))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (report.data.emotion_scale)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_ctx.$filters.emoji(
														report.data
															.emotion_scale + ''
													).message), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _hoisted_87,
                        _createElementVNode("div", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.data
									.assessments_by_skill, (ass, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "mt-10"
                            }, [
                              _createElementVNode("div", _hoisted_88, _toDisplayString(index + 1) + ". " + _toDisplayString(ass?.skill?.name), 1),
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("div", _hoisted_91, [
                                    _createElementVNode("table", _hoisted_92, [
                                      _hoisted_93,
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ass?.assessments, (assessment, index) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: assessment.id,
                                            class: _normalizeClass([
															index % 2 === 0
																? 'bg-white'
																: 'bg-neutral-50'
														, "text-neutral-700 hover:bg-orange-50 cursor-pointer"]),
                                            onClick: ($event: any) => (
															_ctx.$router.push(
																`/goal/${_ctx.student.id}/${assessment.goal_id}`
															)
														)
                                          }, [
                                            _createElementVNode("td", _hoisted_95, [
                                              _createElementVNode("div", null, _toDisplayString(index + 1), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_96, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", {
                                                  class: "w-96 whitespace-normal",
                                                  innerHTML: 
																		assessment
																			?.goal
																			?.name
																	
                                                }, null, 8, _hoisted_97),
                                                (
																		assessment
																			?.goal
																			?.assistance_levels
																	)
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(assessment
																			?.goal
																			?.assistance_levels, (ass) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: 
																			ass
																		
                                                      }, [
                                                        _createElementVNode("div", _hoisted_98, _toDisplayString(ass), 1)
                                                      ]))
                                                    }), 128))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_99, [
                                                  (
																			assessment
																				?.goal
																				?.has_media
																		)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, _hoisted_102))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_103, " ĐÃ HỌC " + _toDisplayString(assessment
																				?.goal
																				?.number_of_assessment) + " NGÀY ", 1),
                                                  (
																			assessment
																				?.goal
																				?.completed_at
																		)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_106))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                (
																		assessment
																			?.goal
																			?.parent
																			?.sub_goal_count >
																		0
																	)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                      _hoisted_108,
                                                      _createElementVNode("div", null, [
                                                        _createElementVNode("div", {
                                                          class: "whitespace-normal text-neutral-700",
                                                          innerHTML: 
																				assessment
																					?.goal
																					?.parent
																					?.name
																			
                                                        }, null, 8, _hoisted_109),
                                                        _createElementVNode("div", _hoisted_110, _toDisplayString(assessment
																					?.goal
																					?.parent
																					?.sub_goal_count) + " MỤC TIÊU ", 1)
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_111, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", {
                                                  style: _normalizeStyle({
																		background:
																			_ctx.$filters.tagResult(
																				assessment?.result
																			)
																				?.background,
																		color: _ctx.$filters.tagResult(
																			assessment?.result
																		)
																			?.color,
																	}),
                                                  class: "mt-1 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-xs shadow-input"
                                                }, _toDisplayString(assessment?.result), 5)
                                              ])
                                            ]),
                                            _createElementVNode("td", {
                                              class: _normalizeClass([{
																'mw-300':
																	assessment
																		.activities
																		.length >
																	0,
															}, "px-3 py-4 whitespace-nowrap text-neutral-700"])
                                            }, [
                                              (
																	assessment.activities
																)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assessment.activities, (a) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: a.id,
                                                        class: "mb-2"
                                                      }, _toDisplayString(a.name), 1))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 2),
                                            _createElementVNode("td", _hoisted_113, [
                                              _createElementVNode("div", _hoisted_114, [
                                                (
																		_ctx.haveMedia(
																			report
																				.data
																				.goal_media,
																			assessment
																				?.goal
																				?.id
																		)
																	)
                                                  ? (_openBlock(), _createElementBlock("svg", {
                                                      key: 0,
                                                      fill: "none",
                                                      height: "20",
                                                      viewBox: "0 0 20 20",
                                                      width: "20",
                                                      xmlns: "http://www.w3.org/2000/svg",
                                                      onClick: _withModifiers(($event: any) => (
																		_ctx.openMediaPopup(
																			report
																				.data
																				.goal_media,
																			0
																		)
																	), ["stop"])
                                                    }, _hoisted_118, 8, _hoisted_115))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_119, [
                                              _createElementVNode("div", _hoisted_120, _toDisplayString(assessment?.note), 1),
                                              (
																	assessment.repeat_in_next_lesson
																)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_121, _hoisted_123))
                                                : _createCommentVNode("", true)
                                            ])
                                          ], 10, _hoisted_94))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ass?.assessments, (assessment) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: assessment.id,
                                    class: "shadow-sm rounded-lg overflow-hidden md:hidden mb-4 bg-white",
                                    onClick: ($event: any) => (
											_ctx.$router.push(
												`/goal/${_ctx.student.id}/${assessment.goal_id}`
											)
										)
                                  }, [
                                    _createElementVNode("div", _hoisted_125, [
                                      _createElementVNode("div", null, _toDisplayString(assessment?.goal?.name), 1),
                                      _createElementVNode("div", _hoisted_126, [
                                        (
														assessment?.goal
															?.raw_source
													)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, _toDisplayString(assessment?.goal
															?.display_source), 1))
                                          : _createCommentVNode("", true),
                                        (
														assessment?.goal?.state
													)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_128, _toDisplayString(_ctx.$filters.sourceMap(
															assessment?.goal
																?.state,
															assessment?.goal
																.editable
														)), 1))
                                          : _createCommentVNode("", true),
                                        (
														assessment?.goal
															?.assistance_levels
													)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(assessment
															?.goal
															?.assistance_levels, (ass) => {
                                              return (_openBlock(), _createElementBlock("div", { key: ass }, [
                                                _createElementVNode("div", _hoisted_129, _toDisplayString(ass), 1)
                                              ]))
                                            }), 128))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_130, [
                                      (
													assessment?.activities_desc
												)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_131, " Hoạt động "))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", null, [
                                        (assessment.activities)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assessment.activities, (a) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: a.id,
                                                  class: "mb-2"
                                                }, _toDisplayString(a.name), 1))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (assessment?.note)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_133, " Nhận xét buổi học "))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", null, _toDisplayString(assessment?.note), 1),
                                      _hoisted_134,
                                      _createElementVNode("div", {
                                        style: _normalizeStyle({
													background:
														_ctx.$filters.tagResult(
															assessment?.result
														)?.background,
													color: _ctx.$filters.tagResult(
														assessment?.result
													)?.color,
												}),
                                        class: "my-2 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-xs shadow-input"
                                      }, _toDisplayString(assessment?.result), 5)
                                    ])
                                  ], 8, _hoisted_124))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
							report.key === 'day_care_report' &&
							report.data?.id &&
							_ctx.tab === index
						)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_136, [
                            _createElementVNode("div", _hoisted_137, [
                              _hoisted_138,
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("div", _hoisted_140, [
                                  (report.data?.date)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_141, _toDisplayString(_ctx.$filters.getDay(
														report.data?.date
													)) + " - " + _toDisplayString(_ctx.$filters.formatDate2(
														report.data?.date
													)), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_router_link, {
                                    to: `/record/employee/${report.data?.submitted_by_staff?.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      (
														report.data
															?.submitted_by_staff
													)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                            _createTextVNode(" Trị liệu viên "),
                                            _createElementVNode("span", _hoisted_143, _toDisplayString(report.data
																?.submitted_by_staff
																?.name), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createElementVNode("div", _hoisted_144, [
                                  _createElementVNode("div", null, [
                                    (report.data?.date)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                          _createTextVNode(_toDisplayString(report.data.session
															?.display_start_slot) + " ", 1),
                                          (
															report.data.session
																?.display_end_slot
														)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_146, " - " + _toDisplayString(report.data.session
																?.display_end_slot), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (
													report.data?.day_care_class
												)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: "/setup-center/boarding"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createTextVNode(" Lớp bán trú "),
                                            _createElementVNode("span", _hoisted_147, _toDisplayString(report.data
																?.day_care_class
																?.name), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_148, [
                            _createElementVNode("div", _hoisted_149, [
                              _hoisted_150,
                              _createElementVNode("div", _hoisted_151, [
                                _createElementVNode("div", _hoisted_152, [
                                  _hoisted_153,
                                  _createElementVNode("div", _hoisted_154, _toDisplayString(report.data
														?.translated_day_care_health), 1)
                                ]),
                                _createElementVNode("div", _hoisted_155, [
                                  _hoisted_156,
                                  _createElementVNode("div", {
                                    style: _normalizeStyle(
													report.data.day_care_eat ===
													'none'
														? 'color: #DB5A41'
														: ''
												),
                                    class: "ml-4"
                                  }, _toDisplayString(report.data
														?.translated_day_care_eat), 5)
                                ]),
                                _createElementVNode("div", _hoisted_157, [
                                  _hoisted_158,
                                  _createElementVNode("div", {
                                    style: _normalizeStyle(
													report.data
														.day_care_sleep ===
													'none'
														? 'color: #DB5A41'
														: ''
												),
                                    class: "ml-4"
                                  }, _toDisplayString(report.data
														?.translated_day_care_sleep), 5)
                                ]),
                                _createElementVNode("div", _hoisted_159, [
                                  _hoisted_160,
                                  _createElementVNode("div", _hoisted_161, [
                                    _createElementVNode("div", _hoisted_162, [
                                      _hoisted_163,
                                      _createElementVNode("div", null, _toDisplayString(report.data
																?.translated_day_care_pee_pee) + " lần ", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_164, [
                                      _hoisted_165,
                                      _createElementVNode("div", _hoisted_166, _toDisplayString(report.data
																?.translated_day_care_poo_poo) + " lần ", 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass([
									report.data.day_care_activities &&
									report.data.day_care_activities.length > 0
										? 'grid-cols-2'
										: 'grid-cols-1'
								, "mt-10 grid md-down:grid-cols-1 gap-8"])
                          }, [
                            (
										report.data.day_care_activities &&
										report.data.day_care_activities.length >
											0
									)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                  _hoisted_168,
                                  _createElementVNode("div", _hoisted_169, [
                                    _createElementVNode("ul", _hoisted_170, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.data
													.day_care_activities, (a) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: a.id,
                                          class: "mb-2"
                                        }, _toDisplayString(a.name), 1))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_171, [
                              _hoisted_172,
                              _createElementVNode("div", _hoisted_173, [
                                _createVNode(_component_Rating, {
                                  rating: 
												report.data?.day_care_scale || 0
											,
                                  class: "max-w-min py-6"
                                }, null, 8, ["rating"]),
                                _createElementVNode("div", {
                                  innerHTML: report.data?.day_care_note
                                }, null, 8, _hoisted_174)
                              ])
                            ])
                          ], 2)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_175, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}